import ApisClient from '../utils/client/ApisClient';

export const getAllSupport = () => {
    return ApisClient.get('/support');
};
